import styled from 'styled-components'

const SectionBreak = styled.hr`
  margin: 0;
  margin-bottom: 10px;
`

export default SectionBreak
